import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/settings/')({
  beforeLoad() {
    throw redirect({
      to: '/settings/authentication/settings/sso'
    });
  }
});